export const STEPS_LIST = [
  {
    name: 'Investing or Holding Entity',
  },
  {
    name: 'Investment',
  },
  {
    name: 'Contributions',
  },
  {
    name: 'Distributions',
  },
  {
    name: 'Valuation',
    description: 'optional',
  },
  {
    name: 'Asset tags',
  },
  {
    name: 'Summary',
  },
]

export const TRANSACTION_TYPE = 'subscribe and commit'
export const TRANSACTION_TYPE_NO_DRAWDOWN = 'add position'

export const ASSET_TYPES_LIST = ['private fund']
export const ASSET_TYPE = ASSET_TYPES_LIST[0]

export const ASSET_CLASSES_LIST = ['Alternative Investments']

export const INVESTMENT_STRATEGIES_LIST = [
  'Private Equity',
  'Private Credit',
  'Growth & Venture',
  'Life Insurance',
]
export const INVESTMENT_STRATEGIES_LIST_NO_DRAWDOWN = ['Hedge Funds']

export const CONTRIBUTION_TYPES = ['capital call', 'asset fees']
export const CONTRIBUTION_TYPES_NO_DRAWDOWN = [
  'capital contribution',
  'asset fees',
]

export const DISTRIBUTION_TYPES = [
  'capital return',
  'recallable capital return',
  'cash dividend',
  'cash interest',
  'realized gain or loss',
  'current income',
]
